import React from 'react';

import _Base from './../_Base';

import {Button, Popup, PopupMessage} from '@components';
import constants from '@constants';
import {Props} from './types';

import './index.scss';

const ChangePlan: React.FC<Props> = props => {
  return (
    <_Base
      title="プラン変更確認"
      isModal={props.isModal}
      handleCloseModal={props.handleCloseModal}
      size="sm"
    >
      <div className="a__change-plan-modal">
        <div className="w__message">
          <div className="b__title-lael">
            プランの変更を行います。注意事項を確認してください。
          </div>
          {props.planDetail.value === constants.PLAN.FREE ? (
            <ul>
              <li>
                スタンダードプランの機能をご利用頂けなくなります
                (SMSでの安否確認・CSV機能)
              </li>
              <li>
                <span className="bold">無料プラン変更と同時</span>
                にスタンダードプラン利用分の請求が発生します
              </li>
              <li>
                再度スタンダードプランを契約した場合、別途請求が発生します
              </li>
            </ul>
          ) : (
            <ul>
              <li>キャンセル・返金は対応致しかねます</li>
              <li>
                月間利用中の<span className="bold">最大登録ユーザー数</span>
                に対して請求が発生します
              </li>
            </ul>
          )}
        </div>

        <div className="w__modal-buttons">
          <Button.Normal
            text="キャンセル"
            onClick={() => props.handleCloseModal(!props.isModal)}
            disabled={props.loading}
          />
          <Button.Normal
            text="変更する"
            onClick={props.onClick}
            color="yellow"
            loading={props.loading}
            disabled={props.loading || props.isForceCanceled}
          />
          {props.isForceCanceled && (
            <Popup.Normal
              content={<PopupMessage.FaildCharging payment />}
              on="click"
              basic
            />
          )}
        </div>
      </div>
    </_Base>
  );
};
export default ChangePlan;
